import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './i18n';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/300-italic.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/500-italic.css';
import '@fontsource/roboto/700-italic.css';
import '@fontsource/roboto-mono/400.css';

ReactDOM.render(
	<App />,
	document.getElementById('root')
);
